// 静态菜单树定义（政企实训管理端）
// authType: '0' 目录 / '1' 菜单
// 顺序即菜单展示顺序：内容管理 → 系统管理
const STATIC_MENU_TREE = [
  {
    authId: 10,
    authName: '内容管理',
    authIcon: 'el-icon-menu',
    authType: '0',
    children: [
      // 模块管理：维护小程序首页8大菜单及其分级窗口内容（树形结构）
      // 仅项目管理员可见（后端 getZqsxModelList/deleteZqsxModel 限定 zauPost=2）
      { authId: 11, authName: '模块管理', authUrl: '/model-manage/list', authIcon: 'el-icon-files', authType: '1', children: [] }
    ]
  },
  {
    authId: 20,
    authName: '系统管理',
    authIcon: 'el-icon-setting',
    authType: '0',
    children: [
      // 用户管理：系统管理员与项目管理员均可见
      { authId: 21, authName: '用户管理', authUrl: '/auth-user/list', authIcon: 'el-icon-user', authType: '1', children: [] },
      // 项目管理：仅系统管理员可见（项目管理员隐藏 —— 即不能创建/管理项目）
      { authId: 22, authName: '项目管理', authUrl: '/auth-project/list', authIcon: 'el-icon-office-building', authType: '1', children: [] }
    ]
  }
]

// 各目录/菜单 authId 常量（用于按岗位过滤）
const CONTENT_DIR_ID = 10 // 内容管理目录
const SYSTEM_DIR_ID = 20 // 系统管理目录
const PROJECT_MANAGE_ID = 22 // 项目管理菜单

// 按岗位过滤菜单（严格对齐后端权限与业务需求）：
// - 系统管理员(zauPost=1)：用户管理 + 项目管理（不含内容管理 —— 模块归项目管理员维护）
// - 项目管理员(zauPost=2)：内容管理(模块) + 用户管理（不含项目管理）
// - 普通用户(zauPost=3)：无任何管理菜单（不应进入后台）
function filterMenuByUser (zauPost) {
  const isAdmin = zauPost === 1
  const isProjAdmin = zauPost === 2

  if (isAdmin) {
    // 系统管理员：内容管理(模块管理) + 系统管理(用户管理 + 项目管理) 全部可见
    return STATIC_MENU_TREE.map(item => ({ ...item, children: item.children || [] }))
  }

  if (isProjAdmin) {
    // 项目管理员：保留「内容管理」目录 + 「系统管理」目录(仅用户管理，不含项目管理)
    return STATIC_MENU_TREE
      .map(item => {
        if (item.authId === SYSTEM_DIR_ID) {
          // 系统管理目录：移除项目管理菜单
          return {
            ...item,
            children: (item.children || []).filter(child => child.authId !== PROJECT_MANAGE_ID)
          }
        }
        return item
      })
  }

  // 普通用户：无菜单
  return []
}

const state = {
  menuTree: STATIC_MENU_TREE,
  routesGenerated: true
}

const mutations = {
  SET_MENU_TREE (state, tree) {
    state.menuTree = tree || STATIC_MENU_TREE
  }
}

const actions = {
  // 根据用户岗位生成可见菜单
  generateMenu ({ commit }, userInfo) {
    const zauPost = userInfo && userInfo.zauPost
    const tree = zauPost !== undefined ? filterMenuByUser(zauPost) : STATIC_MENU_TREE
    commit('SET_MENU_TREE', tree)
  },
  resetPermission ({ commit }) {
    commit('SET_MENU_TREE', STATIC_MENU_TREE)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
